module.exports = __webpack_public_path__ + "img/trial1-3.c9b7f5f5.png";